<span class="pill pill-{{ style.variant }}">
  <i class="las {{ style.icon }}" aria-hidden="true"></i>{{ style.label }}
</span>
